// import { gql, useQuery } from "@apollo/client";
import cn from "classnames";
import React from "react";
import { BiBell } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";
// import { UserQuery } from "../../../../store/models/users";

// const FETCH_USER_SELF = gql`
//   query userSelf {
//     userSelf {
//       fullName
//     }
//   }
// `;

const Header = () => {
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const { loading, error, data } = useQuery<UserQuery>(FETCH_USER_SELF);

  return (
    <div className="flex items-center flex-none">
      {/* <div className="text-gray-800 text-xl font-bold">Dashboard</div> */}
      <div className="ml-auto flex">
        <button
          className={cn(
            "w-10 h-10 rounded-full bg-gray-200 mr-4",
            "text-gray-500 transition-all",
            "flex items-center justify-center",
            "outline-none focus:outline-none focus:ring ring-gray-200 ring-opacity-40",
            "hover:border-gray-200 hover:ring"
          )}
        >
          <BiBell size={20} />
        </button>
        <button
          className={cn(
            "w-10 h-10 rounded-full bg-gray-200",
            "text-gray-500 transition-all",
            "flex items-center justify-center",
            "outline-none focus:outline-none focus:ring ring-gray-200 ring-opacity-40",
            "hover:border-gray-200 hover:ring"
          )}
        >
          <FaUser size={20} />
        </button>
      </div>
    </div>
  );
};

export default Header;
